import React from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

class NeedInitComponent extends React.Component {
  render() {
    return (
      this.props.inited
        ? this.props.children
        : <div className="loading-screen"><Spin indicator={<LoadingOutlined style={{ fontSize: 50 }} spin />} /></div>
    );
  }
}

const mapStateToProps = (state) => ({
  inited: state.init.inited,
});
export default connect(mapStateToProps)(NeedInitComponent);
